'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { ProductListItem } from '@/common/types/product.type';
import { useDomainStore } from '@/store/use-domain.store';
import Price from '@/common/components/price/price.component';
import { appConfigs } from '@/common/configs/app.config';
import { rialToToman } from '@/common/utils/money-exchange.utility';
import ProductDisplay from './product-display.component';

interface ProductProps {
  itemDetail: ProductListItem;
}
function Product({ itemDetail }: ProductProps) {
  const { id, price, discount, name, productSlug, ...rest } = itemDetail;
  const pathName = usePathname();
  const discountNum = Math.round(discount * 100);
  const isTenant = useDomainStore((state) => state.isTenant);
  const formattedPrice = rialToToman(price, appConfigs.rialExchangeRate);

  return (
    <div
      className="box-border h-full  overflow-hidden border-none lg:max-w-[20vw]"
      id={id?.toString()}
      data-id="store-click-product-v1"
    >
      <Link
        href={`/${isTenant ? 'product' : pathName.split('/')[1]}/${id}/${productSlug}`}
      >
        <ProductDisplay
          productName={itemDetail.name}
          availability={rest.availability}
          thumbnailImage={rest.thumbnailImage}
          discount={discountNum}
        />
        <h3 className="mb-1 line-clamp-1 min-h-4 text-ellipsis text-xs font-medium lg:text-sm">
          {name}
        </h3>
        <Price
          price={formattedPrice}
          discount={discountNum !== 0 ? discountNum : undefined}
          alignment="horizontal"
          priceClassName="text-black-default  text-sm  lg:text-sm font-medium"
          discountClassName="text-black-300 text-sm lg:text-sm  font-medium leading-[18px]"
        />
      </Link>
    </div>
  );
}

export default Product;
